import styled from "styled-components";

const TabContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export default TabContent;
